import { useQuery } from '@tanstack/react-query'
import { CATEGORIES, EXPENSES } from '../../constants/endpoints'
import { getPublicCategories } from '../../utils/getPublicCategories'

export const usePublicExpensesCategoriesQuery = () => {
  return useQuery({
    queryKey: [EXPENSES, CATEGORIES, 'public'],
    queryFn: getPublicCategories,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
